export default "__VITE_ASSET__aa467107__"